import insightsApi from "../../api/insightsApi";

// The calls the impact register makes, in one place.
const registerApi = {
    getImpacts: (projectId) => insightsApi.getImpacts(projectId),
    createImpact: (projectId, payload) => insightsApi.createImpact(projectId, payload),
    // `projectId` is unused: the detail route is not project-scoped.
    updateImpact: (projectId, impactId, payload) => insightsApi.updateImpact(impactId, payload),
    deleteImpact: (projectId, impactId) => insightsApi.deleteImpact(impactId),

    getSegments: (projectId) => insightsApi.getSegments(projectId),
    createSegment: (projectId, payload) => insightsApi.createSegment(projectId, payload),
    updateSegment: (projectId, segmentId, payload) => insightsApi.updateSegment(projectId, segmentId, payload),
    deleteSegment: (projectId, segmentId) => insightsApi.deleteSegment(projectId, segmentId),
};

export default registerApi;
